import axios from 'axios';

const serverUrl = process.env.REACT_APP_SERVER_URL;

let usersCache = { at: 0, promise: null };
const USERS_TTL = 5 * 60 * 1000;

/**
 * Admin users list (cached for 5 minutes in memory). Each entry comes from
 * /admin/getUsers: { userId, email, creationTime, lastSignInTime, ... }.
 */
export async function fetchAdminUsers(currentUser, { force = false } = {}) {
  const fresh = usersCache.promise && Date.now() - usersCache.at < USERS_TTL;
  if (fresh && !force) return usersCache.promise;

  const promise = (async () => {
    const idToken = await currentUser.getIdToken();
    const response = await axios.get(`${serverUrl}/admin/getUsers?cache=${!force}`, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${idToken}`,
      },
    });
    return Array.isArray(response.data) ? response.data : [];
  })();

  usersCache = { at: Date.now(), promise };
  promise.catch(() => {
    usersCache = { at: 0, promise: null };
  });
  return promise;
}

export function clearAdminUsersCache() {
  usersCache = { at: 0, promise: null };
}
